import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@material-ui/core";
import TextareaAutosize from '@mui/base/TextareaAutosize';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "0.5%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    color: palette.primary.menuHeader,
  },
  accordionSumary: {
    backgroundColor: palette.primary.light,
  },
  margin: {
    margin: theme.spacing(0),
    width: "100%",
    marginBottom: "1%",
  },
}));

const ComercialOrderProduct = ({
  comercialOrderPro,
  setComercialOrderPro,
  errors,
  open,
  setOpen,
  dataPedidoComercial,
  setPedidoComercial,
}) => {
  const classes = useStyles();
  const classesGlobal = useStylesGlobal();
  const classesApp = useStylesApp();

  const handleChange = (event) => {
    setComercialOrderPro({
      ...comercialOrderPro,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeInfAdicional = (event) => {
    setComercialOrderPro({
      ...comercialOrderPro,
      [event.target.name]: event.target.value.replace(/[&]/ig, ""),
    });
  };

  const handleClickOpen = () => {
    if (dataPedidoComercial != null) {
      setComercialOrderPro(dataPedidoComercial);
    }
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={handleClickOpen}
        >
          <label className={classesGlobal.titleCard}>
            Información del pedido comercial relacionada con el item:{" "}
          </label>
          <label className={classesGlobal.click}>
            <label> </label> (Clic Aquí)
          </label>
        </AccordionSummary>
        <AccordionDetails>
          <from style={{ width: "100%" }}>
            <Grid
              container
              xs={12}
              md={12}
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={12} md={3}>
                <label># Pedido de compra:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={3}>
                <input
                  type="string"
                  className="form-control"
                  name="nroPedidoCompra"
                  value={comercialOrderPro.nroPedidoCompra}
                  onChange={handleChange}
                />
                {errors.nroPedidoCompra ? (
                  <p className={classesApp.errorLetters}>
                    {errors.nroPedidoCompra}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={3}>
                <label># Secuencial del ítem:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={3}>
                <input
                  type="string"
                  className="form-control"
                  name="nroSecuencial"
                  value={comercialOrderPro.nroSecuencial}
                  onChange={handleChange}
                />
                {errors.nroSecuencial ? (
                  <p className={classesApp.errorLetters}>
                    {errors.nroSecuencial}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={3}>
                <label>Información adicional:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={9}>
                <TextareaAutosize
                  minRows={3}
                  type="string"
                  className="form-control"
                  name="informacionInteres"
                  value={comercialOrderPro.informacionInteres}
                  onChange={handleChangeInfAdicional}
                />
                {errors.informacionInteres ? (
                  <p className={classesApp.errorLetters}>
                    {errors.informacionInteres}
                  </p>
                ) : null}
              </Grid>
            </Grid>
          </from>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
export default ComercialOrderProduct;
